
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from './Skleton/Loader';


export default function ViewReportedDisaster() {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [cityy, setcityy] = useState('')
  const nav = useNavigate()


  const [agency, setagency] = useState([])

  const [dosplayagency, setdosplayagency] = useState(false)


  const [filter, setfilter] = useState([])

  const [filteropen, setfilteropen] = useState(false)

  const [isloading, setisloading] = useState(false)

  useEffect(() => {
    fetchSuggestions();
  }, [inputValue]);



  const fetchSuggestions = () => {
    const mapboxAccessToken = 'pk.eyJ1IjoicHJhdGhhbTcwNCIsImEiOiJjbG1xaDJrdzEwNHVpMnFwaXloODIwc2Q0In0.M-0gUqeNHe6A9Z7LeaVFVw'; // Replace with your Mapbox access token

    fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${inputValue}.json?country=IN&types=place&access_token=${mapboxAccessToken}`
    )
      .then((response) => response.json())
      .then((data) => {
        // Filter the results to get only city names
        const cityNames = data.features
          .filter((feature) => feature.place_type.includes('place'))
          .map((feature) => feature.place_name.split(',')[0]);

        // Update the suggestions state
        setSuggestions(cityNames);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };




  async function allagencyinmycity(city) {
    
    setisloading(true)

    setcityy(city)
    const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/getReportedcity', {
      method: 'POST',
      body: JSON.stringify({ city }),
      headers: { 'Content-Type': 'application/json' },
    });
  
    if (res.ok) {
      const ans = await res.json();
      console.log(ans);
  
      if (ans === "notdone") {

        setagency(ans);

setdosplayagency(true)
      }


      else{


        setagency(ans);
        setdosplayagency(true)

      }
    } else {
      console.error("Error fetching achievements");
    }


    setisloading(false)
  }
  















  return (
   <>
   
   <div className="mt-4 p-4 border rounded-lg shadow-md" style={{ width: '90%', marginLeft: '5%', marginRight: '5%' }}>
        <input
          type="text"
          placeholder="Enter a city"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className="w-full p-2 border rounded-md shadow-inner focus:shadow-outline"
        />

        <ul className="mt-2">
          {suggestions.map((city, index) => (
            <li    onClick={()=>{
       setInputValue(city)
       allagencyinmycity(city)


            }}  key={index} className="p-2 border-b last:border-b-0">
              {city}
            </li>
          ))}
        </ul>
      </div>
   
   

{isloading?<>





  <br />
    <br />


<Loader/>
<Loader/>







</>:<>








   
{dosplayagency?<>



{Array.isArray(agency) && agency.length > 0 ? (

    <>



    <br />
    <br />



    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
  {agency.map((a) => (
    <div
      key={a._id}
      className="custom-agency-card bg-blue-100 p-3 rounded-lg shadow-md cursor-pointer my-4 mx-5 relative"
      onClick={() => { nav(`/viewagency/${a.agencyId}`); }}
    >
      <div
  className="bg-gray-300 text-black px-2 py-1 rounded-md  top-2 "
  style={{ zIndex: 1 , width: '14rem' }}	
      >
  {new Date(a.createdAt).toLocaleString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })}      </div>

      <br />
      <br />

      <div className="mb-2">
        <p className="text-gray-600">Agency ID:</p>
        <p className="text-black font-semibold">{a.agencyId}</p>
      </div>

      <div className="mb-2">
        <p className="text-gray-600">City:</p>
        <p className="text-black font-semibold">{a.city}</p>
      </div>

      <div className="mb-2">
        <p className="text-gray-600">Disaster Type:</p>
        <p className="text-black font-semibold">{a.disastertype}</p>
      </div>

      <div className="mb-2">
        <p className="text-gray-600">Severity:</p>
        <p className="text-black font-semibold">{a.severity}</p>
      </div>

      <div>
        <p className="text-gray-600">Description:</p>
        <p className="text-black font-semibold">{a.description}</p>
      </div>
    </div>
  ))}
</div>












  </>
) : (
  <div className="earthquake-info-container">
    <div className="earthquake-info-box2 cursor-pointer">
      <p>NO AGENCY IN UR REGION</p>
    </div>
  </div>
)}







</>:<>



<div className="earthquake-info-container">
    <div className="earthquake-info-box2 cursor-pointer">
      <p>please search
</p>
    </div>
  </div>




</>}



   







</>}


   
   
   
   
   </>
  )
}
